import { BaseApiRouteService } from "mrb/core";

class LoadioApiRouteService extends BaseApiRouteService {
    constructor() {
        super("loadio");
    }

    updateMasterPassword(resource) {
        return super.update(`${this.base}/master-password`, resource);
    }
}

export default LoadioApiRouteService;
